// extracted by mini-css-extract-plugin
export var container = "wave-module--container--1dyFU";
export var inner = "wave-module--inner--LggmW";
export var isBottom = "wave-module--isBottom--D+c2o";
export var isFlip = "wave-module--isFlip--3mBHA";
export var isTop = "wave-module--isTop--fTdM0";
export var wave = "wave-module--wave--WBMG7";